<template>
  <transition name="slide">
    <div class="kfc-calendar">
      <div class="kfc-calendar-header">
        <h1 class="kfc-calendar-today">
          <i
            @click="toUp"
            class="iconfont icon-youjiantou toleft"
            v-show="curDate.ym > formatTime(today).ym"
          ></i
          ><span class="text"
            >{{ curDate.year }}年<i>{{ curDate.month }}月</i></span
          ><i
            class="iconfont icon-youjiantou"
            @click="toNext"
            v-show="last < 6"
          ></i>
        </h1>
        <ul class="kfc-calendar-days">
          <li class="kfc-calendar-day kfc-calendar-weekend">日</li>
          <li class="kfc-calendar-day">一</li>
          <li class="kfc-calendar-day">二</li>
          <li class="kfc-calendar-day">三</li>
          <li class="kfc-calendar-day">四</li>
          <li class="kfc-calendar-day">五</li>
          <li class="kfc-calendar-day kfc-calendar-weekend">六</li>
        </ul>
      </div>
      <div ref="wrapper" class="kfc-calendar-wrapper">
        <ul class="kfc-calendar-dates">
          <li v-for="(value, index) in dates" class="kfc-calendar-date">
            <button
              v-if="value.ymd"
              class="default"
              :class="{
                today: formatTime(today).ymd === value.ymd,
                choosed: chooseTime.ymd === value.ymd
              }"
              :disabled="formatTime(today).ymd > value.ymd"
              @click="choose(value)"
            >
              {{ value.date }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
/*eslint-disable*/
export default {
    name: 'Calendar',
    props: {
        initial: {
            type: [Number, String],
            default: 6
        },
        disabledTimes: {
            type: Array,
            default() {
                return []
            }
        },
        canTop: {
            type: Boolean,
            default: true
        },
        canBottom: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            dates: [],
            scrollY: 0,
            scrollH: 0,
            state: true,
            direction: '',
            chooseTime: {},
            first: 0,
            curMonth: (new Date()).getMonth() + 1,
            nowMonth: (new Date()).getMonth() + 1,
            last: this.initial - 1,
            monthData:[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            curDate: this.formatTime(new Date())
        }
    },
    computed: {
        today () {
            return new Date()
        }
    },
    watch: {
        // disabledTimes(value) {
        //     this.dates = this.dates.map((allArr) => {
        //         return allArr.map((v) => {
        //             if (v.ymd) {
        //                 v.disabled = this.disabledTimes.some(value => value === v.ymd)
        //             }
        //             return v
        //         })
        //     })
        // }
    },
    methods: {
        zerofill(number) {
            return number < 10 ? `0${number}` : number
        },
        formatTime(time) {
            const year = time.getFullYear()
            const month = time.getMonth() + 1
            const displayMonth = time.getMonth() + 1
            const date = time.getDate()
            const day = time.getDay() || 7
            const ymd = `${year}-${this.zerofill(displayMonth)}-${this.zerofill(date)}`
            const ym = `${year}-${this.zerofill(displayMonth)}`
            const formatTime = `${year}年${displayMonth}月`
            return {
                year,
                month,
                displayMonth,
                date,
                day,
                ymd,
                ym,
                formatTime
            }
        },
        getDates(index) {
            // debugger;
            const t = new Date()
            t.setFullYear(this.curDate.year)
            t.setMonth(this.curDate.month, 0)
            let { month } = this.formatTime(t)
            t.setMonth(month + index, 0)
            this.curDate = this.formatTime(t)
            const datesNum = t.getDate()
            let arr = [...new Array(datesNum)]
            month = t.getMonth()
            t.setMonth(month, 1)
            const dayFirst = t.getDay() || 7
            let fixArr = [...new Array(dayFirst)]
            fixArr = fixArr.map((v) => {
                return {}
            })
            arr = arr.map((v, i) => {
                t.setMonth(month, i + 1)
                const tObj = this.formatTime(t)
                return tObj
            })
            const allArr = fixArr.concat(arr)
            this.dates = allArr
            this.$nextTick(() => {
                this.state = true
            })
        },
        choose(value) {
            this.chooseTime = value
            this.$emit('choose', value)
        },
        toUp() {
            this.state = false
            this.getDates(-1)
        },
        toNext() {
            this.state = false
            this.last += 1
            this.getDates(1)
        }
    },
    created() {
        [...new Array(this.initial)].forEach((v, i) => {
            this.getDates(i)
        });
    }
}
</script>

<style lang="scss">
@import './style';
.toleft{
    display: inline-block;
    transform: rotate(180deg);
}
</style>
